module.exports = __webpack_public_path__ + "static/notice-punctuation-dont-50cb57db7e1ee3ee1e6fcb4bf0f1ce5a.png";